import React from 'react';

type SvguserProps = React.SVGProps<SVGSVGElement>;

const Svguser: React.FC<SvguserProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="21"
    fill="none"
    viewBox="0 0 21 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 0.5C7.15606 0.5 4.43555 3.22051 4.43555 6.56445C4.43555 9.90839 7.15606 12.6289 10.5 12.6289C13.8439 12.6289 16.5645 9.90839 16.5645 6.56445C16.5645 3.22051 13.8439 0.5 10.5 0.5ZM18.0453 16.5908C16.385 14.905 14.184 13.9766 11.8477 13.9766H9.15234C6.81605 13.9766 4.61496 14.905 2.95465 16.5908C1.30247 18.2684 0.392578 20.4827 0.392578 22.8262C0.392578 23.1983 0.694273 23.5 1.06641 23.5H19.9336C20.3057 23.5 20.6074 23.1983 20.6074 22.8262C20.6074 20.4827 19.6975 18.2684 18.0453 16.5908Z"
      fill="#54606F"
    />
  </svg>
);

export default Svguser;
